import React from "react"
import { useTableInputForecast } from "./useTableInputForecast.js"
import { Button } from "react-bootstrap"
import { Popup } from "../../../../../component/atoms/Popup/index.jsx"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { Skeleton } from "@material-ui/lab"
import { stringFormatting } from "../../../../helpers/TextHelper.js"
import { Add } from "@material-ui/icons"
import { t } from "i18next"
import { Search } from "../../../../../component/index.jsx"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import SVG from "react-inlinesvg"
import clsx from "clsx"
import { UNIT_STRING } from "../../../../../constants/StringConstant.js"

export default function TableInputForecast() {
  const page = useTableInputForecast()
  const sortedData = page.data

  function renderNumber({ value = undefined, disable = false, fo, mitra, key, month }) {
    const data = { fo: fo, mitra: mitra, key, month }
    return (
      <input
        data-test={mitra ? "input-forecast-mitra" : "input-forecast-preview"}
        value={value === 0 ? undefined : value}
        disabled={page.checkDisableInputForecast(
          page.year,
          page.isFromHistory || disable
        )}
        type={"number"}
        onKeyDown={(e) => {
          if (e.key === "." || e.key === "e" || e.key === "E") {
            e.preventDefault()
          }
        }}
        placeholder={"0"}
        onChange={(e) => {
          let newValue = e.target.value

          if (newValue.includes(".")) {
            let decimalPart = newValue.split(".")[1]
            if (decimalPart && decimalPart.length > 2) {
              newValue = parseFloat(newValue).toFixed(2)
            }
          }

          page.onChangeValue({ target: { value: newValue } }, data)
        }}
        onBlur={(e) => page.onChangeValue(e, data, true)}
        style={{
          border: "none",
          outline: "none",
          textAlign: "center",
          width: "100%",
          background: "transparent"
        }}
      />
    )
  }

  function renderRow(children) {
    return <div className={"py-3 px-3"}>{children}</div>
  }

  function renderBigRow(children) {
    return (
      <div
        className="d-flex align-items-center   px-3 h-100"
        style={{ height: "100%", display: "flex" }}>
        {children}
      </div>
    )
  }

  function renderTableHead(chidlren) {
    return <th className="py-5 px-3 bg-disabled">{chidlren}</th>
  }

  return (
    <div>
      {page.loadingInitForecast ? (
        <div
          className="d-flex justify-content-center align-items-center w-100"
          style={{ height: "10vh", width: "100%" }}>
          <div>Loading...</div>
        </div>
      ) : (
        <div>
          {!page.isFromHistory && (
            <div className="border rounded-top py-4 px-5 d-flex align-items-center justify-content-between">
              {!page.isFromHistory ? (
                <h5 className={"font-weight-bolder"}>{t("label_input_forecast")}</h5>
              ) : (
                <br />
              )}
              {page.loadingSubmit && (
                <div className="d-flex align-items-center">
                  <img src={ICON_CONSTANTS.LOADING_FORECAST} />
                  <div className="px-3">{t("label_saving")}</div>
                </div>
              )}
              {page.loadingDelete && (
                <div className="d-flex align-items-center">
                  <img src={ICON_CONSTANTS.LOADING_FORECAST} />
                  <div className="px-3">{t("label_deleting")}</div>
                </div>
              )}
            </div>
          )}
          <Popup
            show={!!page.targetFO}
            textButton={t("button_save_id")}
            titleCustom={
              <h5 className="mb-0 font-weight-bolder">{t("placeholder_select_mitra")}</h5>
            }
            closeButton={true}
            isLoading={page.isMitraListLoading}
            onCancel={() => {
              page.resetMitraSearch()
              page.setTargetFO(undefined)
            }}
            onClick={() => {
              page.resetMitraSearch()
              page.handleAddMitra()
            }}
            buttonRight={true}
            bodyCustomClassName={"px-6 py-2"}
            bodyCustom={
              !page.isMitraListLoading ? (
                <div>
                  <div className="filter-container mt-5 mb-4">
                    <Search
                      customClass="w-full paddingx-3 paddingy-2"
                      isActiveSearch={page.isActiveSearch}
                      placeholder={t("placeholder_search_mitra_here")}
                      onSubmitForm={page.onMitraSearch}
                      initialValues={page.search}
                      innerRef={page.formMitraSearchRef}
                      name={"keyword"}
                      trigerReset={page.resetMitraSearch}
                    />
                  </div>
                  {Array.isArray(page.mitraList) && page.mitraList.length > 0 ? (
                    <div style={{ overflowY: "scroll", overflowX: "hidden", height: "256px" }}>
                      {(
                        (page.isActiveSearch && page.search?.keyword !== ""
                          ? page.mitraList.filter((mitraListItem) =>
                              mitraListItem.name.toLowerCase().includes(page.search.keyword.toLowerCase())
                            )
                          : page.mitraList) || []
                      ).map((mitraItem) => (
                        <RowModule key={mitraItem.id}>
                          <div>
                            <div className="custom-option">
                              <div
                                className="checkbox-container"
                                onClick={(event) => {
                                  page.onMitraCheckChange(event, mitraItem)
                                }}>
                                <input type="checkbox" checked={mitraItem.selected} readOnly />
                                <span className="checkmark"></span>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start"
                              }}>
                              <span
                                className="font-black fw-normal pl-10"
                                style={{ fontWeight: "normal", color: "black" }}>
                                {stringFormatting(mitraItem.name)}
                              </span>
                            </div>
                          </div>
                        </RowModule>
                      ))}
                    </div>
                  ) : (
                    <div className={"d-flex flex-column justify-content-center align-items-center"}>
                      <SVG src={ILLUSTRATION_CONSTANTS.EMPTY_STATE} />
                      <span className={"text-center mt-12 font-weight-bolder mb-1 font-size-lg"}>
                        {t("messages_response_data_not_found")}
                      </span>
                    </div>
                  )}
                </div>
              ) : (
                Array.from({ length: 5 }).map((_, i) => (
                  <Skeleton
                    animation={"wave"}
                    height={32}
                    variant={"rect"}
                    key={i}
                    className={"mb-5"}
                  />
                ))
              )
            }
          />
          <table className=" table-bordered w-100">
            <thead className="text-start">
              <tr>
                {renderTableHead(t("table_header_month").toUpperCase())}
                {renderTableHead(t("menu_aside_field_officer").toUpperCase())}
                {renderTableHead(t("label_mitra").toUpperCase())}
                {page.plantList.map((plantItem) =>
                  renderTableHead(`${plantItem.name.toUpperCase()} (${UNIT_STRING.HA})`)
                )}
              </tr>
            </thead>
            <tbody>
              {sortedData.map((month) => {
                const totalMonthRowSpan =
                  Array.isArray(month.fieldOfficers) && month.fieldOfficers.length > 0
                    ? month.fieldOfficers.reduce((sum, fo) => sum + (fo.mitras || []).length + 2, 0)
                    : 2

                return (
                  <React.Fragment key={month.month_number}>
                    {(month.fieldOfficers || []).map((fo, foIndex) => {
                      const foRowSpan = (fo.mitras || []).length + 2

                      return (
                        <React.Fragment key={fo.id}>
                          {(fo.mitras || [])?.map((mitra, mitraIndex) => (
                            <tr key={mitra.id}>
                              {foIndex === 0 && mitraIndex === 0 && (
                                <td rowSpan={totalMonthRowSpan} style={{ height: "100%" }}>
                                  {renderBigRow(month.name)}
                                </td>
                              )}
                              {mitraIndex === 0 && (
                                <td rowSpan={foRowSpan} style={{ width: "230px" }}>
                                  {renderRow(fo.name)}
                                </td>
                              )}
                              {!mitra?.isInitial && (
                                <td style={{ width: "260px" }}>
                                  <div
                                    data-test="render-list-mitra-name"
                                    className={
                                      "d-flex justify-content-between align-items-center mx-3"
                                    }>
                                    {renderRow(mitra.name)}
                                    <div
                                      onClick={() => {
                                        if (!page.isFromHistory) {
                                          page.removeMitraFromFO(
                                            month.month_number,
                                            fo.id,
                                            mitra.mitra_id,
                                            mitra.id
                                          )
                                        }
                                      }}>
                                      {!page.isFromHistory ? (
                                        <SVG
                                          style={{ height: "20px", width: "20px" }}
                                          src={ICON_CONSTANTS.REMOVE}
                                          alt="edit"
                                        />
                                      ) : (
                                        <SVG
                                          style={{ height: "20px", width: "20px" }}
                                          src={ICON_CONSTANTS.REMOVE_OUTLINE_WHITE}
                                          alt="edit"
                                        />
                                      )}
                                    </div>
                                  </div>
                                </td>
                              )}
                              {!mitra?.isInitial &&
                                (mitra.forecast || [])?.map((item) => (
                                  <td key={item.plant_type_id} style={{ width: "260px" }}>
                                    {renderNumber({
                                      value: item.value,
                                      mitra,
                                      fo: fo.id,
                                      month: month,
                                      key: item.plant_type_id
                                    })}
                                  </td>
                                ))}
                            </tr>
                          ))}

                          <tr>
                            <td className={clsx([!!page.isFromHistory && "bg-disabled"])}>
                              <div
                                onClick={() =>
                                  !page.isFromHistory &&
                                  page.setTargetFO({ month: month.month_number, fo: fo.id })
                                }
                                className={clsx(
                                  "d-flex align-items-center p-3",
                                  !page.isFromHistory ? "text-primary-green" : "text-neutral-gray"
                                )}
                                style={{
                                  display: "flex",
                                  cursor: !page.isFromHistory ? "pointer" : "default"
                                }}>
                                <Add fontSize={"large"} style={{ marginRight: "10px" }} />
                                <span>{t("placeholder_select_mitra")}</span>
                              </div>
                            </td>
                            {(((Array.isArray(fo.mitras) && fo.mitras.length > 0) ? fo.mitras[0] : [])?.forecast || []).map((_, idx) => (
                              <td
                                key={idx}
                                className={clsx([
                                  !!page.isFromHistory && "bg-disabled",
                                  "text-gray-400"
                                ])}>
                                {renderRow(renderNumber({ value: 0, disable: true }))}
                              </td>
                            ))}
                          </tr>

                          <tr className="bg-gray-50 font-semibold">
                            <td className={"card-header-bg-gray"}>
                              <div
                                className={clsx(
                                  "mx-3 font-weight-boldest",
                                  !page.isFromHistory ? "text-neutral-gray" : "text-negative-color-2"
                                )}>
                                {renderRow("Total")}
                              </div>
                            </td>
                            {(() => {
                              const summedData = page?.sumDataMitras(fo)
                              return summedData?.map((item, idx) => {
                                return (
                                  <td
                                    key={idx}
                                    style={{ textAlign: "center" }}
                                    className={
                                      "font-weight-boldest card-header-bg-gray text-neutral-gray"
                                    }>
                                    {item?.value ? parseFloat(item.value).toFixed(2) : 0}
                                  </td>
                                )
                              })
                            })()}
                          </tr>
                        </React.Fragment>
                      )
                    })}
                  </React.Fragment>
                )
              })}
            </tbody>
          </table>
          {!page.isFromHistory && (
            <div className="border py-4 px-5">
              <Button
                color="primary"
                variant="text"
                disabled={page.checkDisableButtonAddMonth}
                onClick={page.onClickAddMonth}>
                <div
                  className={clsx(
                    !page.checkDisableButtonAddMonth
                      ? "text-primary-green"
                      : "text-neutral-medium-gray"
                  )}
                  style={{
                    gap: 12,
                    alignItems: "center",
                    display: "flex",
                    cursor: !page.checkDisableButtonAddMonth ? "pointer" : "default"
                  }}>
                  <Add style={{ height: 26, width: 26 }} />
                  {t("label_add_month")}
                </div>
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}